module.exports = __webpack_public_path__ + "static/media/hn.b1a14dda.webp";